import { combineReducers } from 'redux';

import apiError from './apiError';
import isLoading from './isLoading';

/** @typedef {{ apiError: string, isLoading: boolean }} AuditsUIDetailsShareSendReducer */

export default combineReducers({
  apiError,
  isLoading,
});
